import { render, staticRenderFns } from "./DevMenu.vue?vue&type=template&id=5cdc2ccc"
import script from "./DevMenu.vue?vue&type=script&lang=js"
export * from "./DevMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports